import { render, staticRenderFns } from "./UserBubble.vue?vue&type=template&id=cc90ce78"
import script from "./UserBubble.vue?vue&type=script&lang=js"
export * from "./UserBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports